import { Component, inject, OnInit, signal } from '@angular/core';
import { CurrentUserService } from '../services/currentUser.service';
import { User } from '../model/user.model';
import { Router } from '@angular/router';
import { UserService } from '../services/user.service';
import { RedirectHelper } from '../helpers/redirect.helper';
import { MessagingService } from '../components/messaging/messaging.service';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { RepairerAdminService } from '../services/repairer-admin.service';
import { NoticeService } from '../services/notice.service';
import { finalize, tap } from 'rxjs/operators';
import { AuthService } from '../auth/auth.service';
import { MatToolbar, MatToolbarRow } from '@angular/material/toolbar';
import { MatDivider } from '@angular/material/divider';
import { MatButton } from '@angular/material/button';

@Component({
  selector: 'app-accept-eula',
  templateUrl: './accept-eula.component.html',
  styleUrls: ['./accept-eula.component.scss'],
  imports: [MatToolbar, MatToolbarRow, MatDivider, MatButton]
})
export class AcceptEulaComponent implements OnInit {
  currentUser: User;
  eulaContent = signal<SafeHtml>('');

  #currentUserService = inject(CurrentUserService);
  #message = inject(MessagingService);
  #noticeService = inject(NoticeService);
  #redirectHelper = inject(RedirectHelper);
  #repAdminService = inject(RepairerAdminService);
  #router = inject(Router);
  #sanitizer = inject(DomSanitizer);
  #userService = inject(UserService);
  #auth = inject(AuthService);

  ngOnInit(): void {
    this.currentUser = this.#currentUserService.currentUserValue;
    fetch('assets/eula/EULA.html')
      .then((res) => res.text())
      .then((data) => {
        this.eulaContent.set(this.#sanitizer.bypassSecurityTrustHtml(data));
      });
  }

  decline() {
    this.#auth.logout().subscribe({
      next: () => {
        this.#router.navigate(['login']).catch();
        this.#currentUserService.userLogout();
      },
      error: () => this.#message.error('Server Error'),
      complete: () => sessionStorage.clear()
    });
  }

  agree() {
    this.#repAdminService.acceptEula(this.currentUser.username).subscribe({
      next: () => {},
      error: () => this.#message.error('Server Error'),
      complete: () =>
        this.#userService
          .getCurrentUser()
          .pipe(
            tap((user) => {
              this.#currentUserService.userLogin(user);
            }),
            finalize(() => {
              this.#noticeService.fetchUnseenNoticesIfPermissible();
              this.#redirectHelper.manageRedirection(this.#currentUserService.currentUserValue, this.#router);
            })
          )
          .subscribe({
            error: (err) => console.error(err)
          })
    });
  }
}
